export default "__VITE_ASSET__3v8i8gV7__"